import { Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import { setDocumentTitle } from "@/lib/documentTitle";

import { A7FIAIssuerTSEdit } from "./edit";
import { A7FIAIssuerTSTable } from "./table";

export default function A7FIAIssuerTS() {
  useEffect(() => {
    setDocumentTitle("Quantilia | FIA Émetteurs Séries Temporelles");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<A7FIAIssuerTSEdit />} />
      <Route index element={<A7FIAIssuerTSTable />} />
    </Routes>
  );
}
